import * as api from "../Api";

export const getAllSpecificBranchAdvice = () => async (dispatch) => {
  try {
    const { data } = await api.getAllSpecificBranchAdvice();
    dispatch({ type: "GET_ALL_SPECIFIC_BRANCH_ADVICE", payload: data });
  } catch (error) {}
};
